export const convertToResizedUrl = (coverPhoto, width = 500, height = 300) => {
  if (!coverPhoto) return "/assets/images/no_photo_big.jpg";
  return coverPhoto.replace("/cms/", `/cms/resize/${width}/${height}/`);
};
